export const PAYMENT = {
  SHOP_CREDIT: 1,
  OMISE: 2,
  CASH: 3,
  TRANSFER: 4, // Bank Transfer
  LINE_PAY: 5,
  KSHER: 6,
  QR: 7, // KBank
  GB_LINK: 8,
  PAY_SOLUTION: 9
}

export const CREDIT_PAYMENT = {
  QR: 'qr',
  GB_CREDIT: 'gb_credit',
  OMISE: 'omise'
}

export const PULL_TO_CONFIG = {
  pullText: 'Pull to refresh',
  triggerText: 'Release to refresh',
  loadingText: 'Loading...',
  doneText: '',
  loadedStayTime: 0
}

export const HOME_THEME = {
  CLASSIC: 1,
  LEVEL_UP: 2,
  BEE_HIVE: 3
}
